module.exports = __webpack_public_path__ + "7d9ae3f273fb7a68c8883eead162c9ab.svg";